import React, { useEffect, useRef, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import { Button, Col, Form, message, Modal, notification, Radio, Row, Spin } from 'antd';
import { HomeOutlined, LoadingOutlined } from '@ant-design/icons';
import ZenChartsInput from './InputCreater/ZenChartsInput';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import digitalFactoryLogo from "../images/DigitalFactory.png";
import { Link } from 'react-router-dom';
import { createRoute, getUrlCode } from '../utils/CustomFunc';
import ReactToPrint from 'react-to-print';
import StAddNew from './DSeries/StAddNew';
import { useSelector } from 'react-redux';
import FooterButtons from '../components/STORM/FooterButtons';
import ZenModal from '../components/ZenModal';
import HModal from './HModal';
import noImg from '../assets/static/noImg.jpeg';


const DynamicZenChart = ({
  setPageHeader,
  urlData,
  chartData,
  api = '/dc'
}) => {
  let componentRef = useRef();
  const [selectedButton, setSelectedButton] = useState();
  const [isHModalVisible, setIsHModalVisible] = useState(false);
  const [action, setAction] = useState({});
  const { search } = useLocation();
  const [smodalForm] = Form.useForm();
  const [smodalLoading, setSmodalLoading] = useState(false);
  const [zenModal, setZenModal] = useState();
  const [modal, setModal] = useState({
    // type: props.config.zenModal.typ,
    type: "kanban",
    data: undefined,
    show: false,
    loading: false,
  });

  const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
    setModal({ show, data, type, loading });
  }

  const dictNames = {
    "add-chart": "ZenChartBuilder_config",
    "upload-json": "ZenFormBuilder_jsonUploader",
    "edit-row": "ZenChartBuilder_rowConfig",
    "edit-chart": "ZenChartBuilder_config"
  };

  const urlCode = useSelector(state => state.urlCode);
  const [modalTitle, setModalTitle] = useState('');
  const searchParams = queryString.parse(search);
  const [chartList, setChartList] = useState();
  const [tabsConfig, setTabsConfig] = useState();
  const [chartConfig, setChartConfig] = useState();
  const [loading, setLoading] = useState(true);
  const [tabsData, setTabsData] = useState();
  const [modalData, setModalData] = useState({
    open: false,
    typ: '',
    data: null,
    loading: false
  });
  const [selectedTab, setSelectedTab] = useState();

  const getChartsData = ({
    currentTab,
    params
  }) => {
    liracrypt.get(api, { ...searchParams, ...urlData, ...params, selectedTab: currentTab })
      .then(({ data }) => {
        if (data.isSuccess) {
          setChartConfig(data.config);
          if (setPageHeader) {
            setPageHeader(data.config.pageTitle || 'Dynamic Zen Charts');
          }
          setChartList(data.config.chartElement);
          setLoading(false);
        }

      }).catch(err => {
        console.log(err);
      })
  }

  const getTabs = () => {
    liracrypt
      .get("/dbtabs", { ...searchParams, ...urlData })
      .then(({ data }) => {
        if (data.isSuccess) {
          setTabsConfig(data.config);
          if (data.data.length) {
            let __tabs = data.data;
            setTabsData(__tabs);
            let selectedTab = __tabs?.find((x) => x.isDefault === true)?.subTyp;
            onTabChange(selectedTab);
          } else {
            getChartsData({});
          }
        } else {
          getChartsData({});
        }
      })
      .catch((err) => {
        console.log(err);
        ApiErrorComp();
        getChartsData({});
      });
  };

  const onTabChange = (val) => {
    setSelectedTab(val);
    getChartsData({
      currentTab: val
    })
  }

  useEffect(() => {
    setLoading(true);
    setSelectedTab(null);
    if (searchParams.showTabs === 'true' || urlData?.showTabs === 'true') {
      getTabs();
    } else {
      if (chartData) {
        setChartList(chartData);
        setLoading(false);
        return;
      }
      getChartsData({});
    }
  }, [JSON.stringify(searchParams)]);

  useEffect(() => {
    if (tabsData && tabsConfig?.tabChangeInterval) {
      let sTab = selectedTab;
      let interval = setInterval(() => {
        if (sTab) {
          let currentTabIndex = tabsData.findIndex(x => x.subTyp === sTab);
          if ((currentTabIndex) < (tabsData.length - 1)) {
            onTabChange(tabsData[currentTabIndex + 1]?.subTyp)
          } else {
            onTabChange(tabsData[0].subTyp)
          }
        }
      }, tabsConfig?.tabChangeInterval);
      return () => clearInterval(interval);
    }
  }, [selectedTab]);

  const onJsonUpload = (values) => {
    setSmodalLoading(true);
    let formData = new FormData();
    // formData.append('dictName', pageConfigData?.dictName);
    // formData.append('_id', pageConfigData?._id);
    Object.keys(values).forEach(x => {
      formData.append(x, values[x]);
    });
    liracrypt.uploadFile('/chartconfig/upload', formData)
      .then(({ data }) => {
        setSmodalLoading(false);
        if (data.isSuccess) {
          toggleModalData({});
          //    message.success(data.message || 'Successfully Saved');
        } else {
          message.success(data.message || 'Something went wrong');
        }
      }).catch(err => {
        setSmodalLoading(false);
        console.log(err);
        message.error('Something went wrong');
      })
  }

  const downloadJson = () => {
    liracrypt.post('/chartconfig/download', {}).then(({ data }) => {
      if (data.isSuccess) {
        window.open(
          `${process.env.REACT_APP_API_ENDPOINT}/fetchfilesingleattachmentzenform?filePath=${data.data.filePath}&fileName=${data.data.fileName}&token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
          '_blank'
        )
      } else {
        message.error(data.message);
      }
    })
  };



  const chartContainer = (item, index) => (
    <Col span={item.colSize || item.chartLayout.colSize} key={`main_${index}`}>
      <div style={item.style}>
        <Row>
          {
            item.chartList.map((chart, chartIndex) => {
              if (chart.chartList) {
                return (
                  <>
                    {chartContainer(chart)}
                  </>
                )
              }
              let chartParams = { ...searchParams, ...urlData, ...chart.chartData?.params };
              if (chart.chartData?.api) {
                chartParams.frame = searchParams.dn;
                delete chartParams.dn;
                chartParams = {
                  typ: chart.typ,
                  ...chartParams,
                  ...chart.chartLayout
                }
              };
              if (chart.chartData) {
                chart.chartData.params = chartParams;
              }
              return (
                <React.Fragment key={`dynamic-zen-chart-${chartIndex}`}>
                  <ZenChartsInput
                    refreshData={(params) => getChartsData({ params, currentTab: selectedTab })}
                    chartData={chart.chartData}
                    src={chart.chartLayout.source}
                    divId={chart.chartLayout.divId || `dynamiz-zen-${chart.typ}-${chartIndex}-${index}`}
                    typ={chart.typ}
                    enable={!chart.chartLayout.hideChart}
                    colSpan={chart.chartLayout.colSize}
                    style={{ ...chart.style, backgroundSize: 'cover', minHeight: chart.chartLayout.hideChart ? '100px' : '' }}
                    imgStyle={chart.imgStyle}
                    label={chart.label}
                  />
                </React.Fragment>
              )
            })
          }
        </Row>
      </div>
    </Col>
  )

  const toggleModalData = ({ open = false, typ = '', data = null, loading = false }) => {
    setModalData({ typ, open, data, loading });
  }

  useEffect(() => {
    let interval;
    if (chartConfig?.dataRefreshInterval) {
      interval = setInterval(() => {
        if (chartList && !tabsData) {
          getChartsData({});
        }
      }, chartConfig?.dataRefreshInterval);
    }
    return () => clearInterval(interval);
  }, [chartList, tabsData, chartConfig?.dataRefreshInterval]);

  const onSmodalSubmit = (values) => {
    if (modalData.typ === 'upload-json') {
      onJsonUpload(values);
    }
  }

  const downloadDocs = (btn) => {
    // let button = btn || selectedButton;
    // if (selectedRowData.length <= 0) return;
    // selectedRowData.forEach(x => {
    //     let urlData = {...searchParams, ...formData, ...btn.fileDownload.params };
    //     if (btn.fileDownload.props) {
    //         urlData[btn.fileDownload.props] = x[btn.fileDownload.props];
    //     }
    //     urlData['token'] = localStorage.getItem("token");
    //     urlData['urlCode'] = urlCode;
    //     let searchParams = new URLSearchParams(urlData);
    //     document.getElementById('downloadLink').setAttribute("href", `${process.env.REACT_APP_API_ENDPOINT}${btn.fileDownload.api}?${searchParams}`);
    //     document.getElementById('downloadLink').click();
    // })
  }

  const finalAction = (action, res) => {
    if (action === "refreshPhantom") {
      notification.success({
        message: res?.data?.message
          ? res?.data?.message
          : "Data Modified Successfully !",
      });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else if (action === "refreshStable") {
      document.getElementById("submitButtonForm").click();
    } else {
      notification.success({
        message: res?.data?.message
          ? res?.data?.message
          : "Data Modified Successfully !",
      });
    }
  };

  const onResponse = ({ button, onlyPostSubmitAction, response }) => {

    // setStormResponse(data);
    let btnData = button || selectedButton;
    if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
      return openPopupModal(btnData);
    };
    if (!btnData?.buttonProp?.postSubmitAction) {
      return;
    };
    // if (btnData?.postSubmitActionProp?.action === "clearForm") {
    //   form.resetFields();
    //   console.log("resetFields33");
    // }
    // if (btnData?.postSubmitActionProp?.action === "blankPage") {
    //   setStormResponse(null);
    // };
    let __urlData = { ...searchParams, ...btnData?.postSubmitActionProp?.params };
    if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
      return document.getElementById("submitButtonForm").click();
    }
    if (btnData?.postSubmitActionProp?.action === "newTab") {
      let route = createRoute({
        route: btnData.postSubmitActionProp.route,
        props: btnData?.postSubmitActionProp?.props,
        multiProps: btnData?.postSubmitActionProp?.multiProps,
        record: {},
        urlCode,
        params: { ...__urlData },
      });
      return window.open(route, '_blank');
    };

    if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
      return window.location.reload();
    }
    if (btnData?.postSubmitActionProp?.action === 'route') {
      setZenModal({
        typ: "route",
        route: btnData?.postSubmitActionProp?.route,
        width: btnData?.postSubmitActionProp?.width,
        pageTitle: btnData?.postSubmitActionProp?.pageTitle
      });
      toggleModal({
        loading: false,
        show: true,
        data: {
          urlData: __urlData
        },
        type: "route"
      });
      return;
    }
    if (btnData?.postSubmitActionProp?.action === 'smodal') {
      setZenModal({
        typ: "smodal",
        ...btnData?.postSubmitActionProp
      });
      toggleModal({
        loading: false,
        show: true,
        data: {
          urlData: __urlData
        },
        type: 'smodal'
      });
      return;
    };
    if (btnData?.postSubmitActionProp?.api) {
      setZenModal({
        typ: btnData?.postSubmitActionProp?.action,
        ...btnData?.postSubmitActionProp
      });
      toggleModal({ show: true, loading: true, type: btnData?.postSubmitActionProp?.action });
      liracrypt.get(`${btnData?.postSubmitActionProp?.api}`, __urlData).then(response => {
        toggleModal({
          show: true,
          data: (btnData?.postSubmitActionProp?.action === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: btnData?.postSubmitActionProp?.action
        })
      });
      return;
    }
    finalAction(btnData?.postSubmitActionProp?.action, response)
  };

  const openPopupModal = (button) => {
    setIsHModalVisible(true);
    setAction({ edit: button.popUpModalProp });
  };

  const onFinish = ({ button }) => {
    if (button?.submitFormDataProp?.method === 'POST') {
      let postData = { ...searchParams, ...urlData, ...button?.submitFormDataProp.params };
      // postData.seldocs = selectedRowData;
      // if (button?.submitFormDataProp?.sendAllData) {
      //     postData = { ...postData, allData: tblConfig.data };
      // }
      liracrypt.post(button?.submitFormDataProp.api, postData).then(response => {
        notification.success({ message: response.data.message });
        onResponse({ button, response })
      })
        .catch(err => {
          notification.error({
            message: 'Something went wrong'
          })
        })
    };
    if (button?.submitFormDataProp?.method === 'PATCH') {
      let postData = { ...searchParams, ...urlData, ...button?.submitFormDataProp.params };
      // if (button?.submitFormDataProp?.sendAllData) {
      //     postData = { ...postData, allData: tblConfig.data };
      // }
      liracrypt.patch(button?.submitFormDataProp.api, postData).then(response => {
        notification.success({ message: response.data.message });
        onResponse({ button, response })
      })
        .catch(err => {
          notification.error({
            message: 'Something went wrong'
          })
        })
    };

  }

  const navigateToSection = (id) => {
    const yOffset = -70;
    const element = document.getElementById(id);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

  }

  const getActiveClass = (id) => {
    const el = document.getElementById('testsfs');
    if (el) {
      const rect = el.getBoundingClientRect();
      console.log(rect.top);
      if (rect.top === 0) return 'active';
    }
  }

  return (
    <div ref={(el) => (componentRef = el)} style={{ padding: 10 }} className={chartConfig?.backgroundTyp === 'img' ? 'bgImg2' : 'bgColor'}>
      {
        loading ?
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Spin indicator={<LoadingOutlined spin style={{ fontSize: 80 }} />} />
          </div> :
          <>
            {
              chartConfig?.isCloned ?
                <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                  <Button ghost style={{ marginRight: 20 }} type="primary" onClick={downloadJson}>
                    Download JSON
                  </Button>
                  <Button
                    ghost
                    style={{ marginRight: 20 }} type="primary" onClick={() => {
                      toggleModalData({
                        open: true,
                        typ: 'upload-json'
                      })
                    }}>
                    Upload JSON
                  </Button>
                </div> : <></>
            }

            {
              tabsData &&
              <div
                style={{
                  display: "inline-flex",
                  alignContent: "center",
                  alignItems: "center",
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                <div
                  className="logo"
                  style={{
                    margingLeft: 14,
                    padding: 10,
                  }}
                >
                  <img src={digitalFactoryLogo} alt="sarex" width="80" />
                </div>
                <Radio.Group
                  className="managerTabs"
                  value={"small"}
                  onChange={(e) => onTabChange(e.target.value)}
                >
                  {
                    tabsData.map((tab, index) => (
                      <Radio.Button
                        key={index}
                        className={`${tab?.label?.toLowerCase()} ${selectedTab === tab?.subTyp ? 'active' : ''}`}
                        style={{
                          background: "#191C24",
                          border: "1px solid #3c3e4f",
                          color: tab?.color,
                          textAlign: "center",
                          fontSize: "17px",
                          fontWeight: 600,
                          // boxShadow: boxShadow,
                          maxWidth: "200px",
                        }}
                        value={tab?.subTyp}
                      >
                        {tab?.label}
                      </Radio.Button>
                    ))}
                </Radio.Group>
                <div
                  style={{
                    //   boxShadow:
                    //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                    borderRadius: 10,
                    padding: 10,
                    marginRight: 25,
                    marginBottom: 13,

                    background: "#191C24",
                    //   backgroundImage:
                    //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                    border: "1px solid #3c3e4f",
                  }}
                >
                  <Link to={`/v02/${getUrlCode()}/dashboard`}>
                    <HomeOutlined
                      style={{
                        fontSize: 25,
                      }}
                    />
                  </Link>
                </div>
              </div>
            }
            {
              chartConfig?.navigationTabs && (
                <div style={{ position: 'sticky', top: 0, padding: 10, marginBottom: 10, zIndex: 10, background: '#000000', display: 'flex', width: '100%', flexWrap: 'wrap', }}>
                  {
                    chartConfig?.navigationTabs?.map((x, i) => (
                      <div key={i} onClick={() => navigateToSection(`dc-container-${x.divId}`)} style={{ ...x.style, color: 'white', border: '1px solid #ffffff', marginRight: 10, cursor: 'pointer' }}>{x.label}</div>

                    ))
                  }
                  {/* <Button type={'primary'} ghost={true} onClick={() => navigateToSection('testsfs')}>Naivgation Test</Button>
              <Button type={'primary'} ghost={true} onClick={() => navigateToSection('stablee')}>Naivgation Test 2</Button> */}
                </div>
              )
            }

            <Row>
              {
                chartList.map(chartContainer)
              }
            </Row>

            <HModal
              submitBtnId={'submitBtnModal'}
              preventSubmitBtnClick={false}
              onResponse={onResponse}
              isModalVisible={isHModalVisible}
              setIsModalVisible={setIsHModalVisible}
              modalMethod={"edit"}
              action={action}
              modalData={null}
              extraData={{ ...urlData }}
            />

            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={({ data }) => { }} />

            {Object.keys(chartConfig?.footerButtons || {})?.length &&
              (
                <div style={{ display: 'inline-flex', justifyContent: 'center', width: '100%' }}>
                  {
                    Object.keys(chartConfig?.footerButtons).map((btn, index) => {
                      const button = chartConfig?.footerButtons[btn];
                      if (button?.buttonProp?.visible) {
                        return (
                          <div key={index} style={{ marginTop: 20 }}>
                            <FooterButtons
                              downloadDocs={downloadDocs}
                              onFinish={onFinish}
                              postSubmitAction={onResponse}
                              openPopupModal={openPopupModal}
                              button={button}
                              setSelectedButton={setSelectedButton}
                              form={null}
                              label={button?.buttonProp?.label}
                              type={button?.buttonProp?.type}
                              disabled={!button?.buttonProp?.enable}
                              confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                              submitFormData={button?.submitFormDataProp}
                            />
                          </div>
                        )
                      }
                    })
                  }
                </div>

              )}

            <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={modalData.open} title={modalTitle || "Add Zen Form Control"} onCancel={() => toggleModalData({})}>
              {
                modalData.loading ?
                  <></> :
                  <>
                    <StAddNew
                      urlMethod={modalData.typ !== 'upload-json' ? "POST" : undefined}
                      formName="ChartBuilderForm"
                      setSmodalTitle={title => { setModalTitle(title) }}
                      initForm={smodalForm}
                      colSpan={24}
                      urlEndpoint={modalData.typ === 'upload-json' ? '/smodal' : '/smodal/zenform'}
                      urlData={{
                        ...modalData.data,
                        dictName: dictNames[modalData.typ]
                      }}
                      onFormSubmit={onSmodalSubmit}
                    />
                    <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                      <Button loading={smodalLoading} htmlType='submit' type="primary" form={'ChartBuilderForm'}>Submit</Button>
                    </div>
                  </>
              }
            </Modal>

            {/* <ReactToPrint
              trigger={() => <Button id="print-form">Print this out</Button>}
              content={() => componentRef}
            /> */}
          </>
      }
    </div>
  )
};

export default DynamicZenChart;